import React, { useState, useEffect, useRef } from 'react';
import SideMenuBar from '../../../Components/Layouts/SideMenuBar';
import TopMenuBar from '../../../Components/Layouts/TopMenuBar';
import RightSideBar from '../../../Components/Layouts/RightSideBar';
import './../../../Styles/Cart/Cart.css';
import greenDot from './../../../assets/greendot.svg';
import redDot from './../../../assets/reddot.svg';
import SubTotal from './SubTotal';
import { useLocation, useNavigate } from 'react-router-dom';
import Address from './AddressListModel';
import { useTranslation } from 'react-i18next';
import emptyCartImg from './../../../assets/empty-cart.png';
import AddOns from './AddOns';
import img1 from '../../../assets/Image1.png';
import { useCart } from '../../../CartProvider';
import FoodMenuDetailsModal from '../Search/FoodMenuDetailsModal';
import axiosUserInstance from '../../../axiosUserInstance';
import axiosVendorInstance from '../../../axiosVendorInstance';
import NotificationIcon from '../../../assets/svg/notificationIcon';
import WhiteLocationIcon from '../../../assets/svg/WhiteLocationIcon';
import DownArrowIcon from '../../../assets/svg/DownArrowIcon';
import Loader from '../../../Components/Loader/Loader';
import { IoPlayOutline } from 'react-icons/io5';
import { useNotifications } from '../Notification/NotificationContext';
import Notification from '../Notification/Notification';
import { Helmet } from 'react-helmet';
import { CONSTANT, SEO } from '../../../Utils/Constant';

function cart() {
    const location = useLocation();
    const [selectedAddressIndex, setSelectedAddressIndex] = useState(() => {
        return localStorage.getItem('selectedAddressIndex')
            ? parseInt(localStorage.getItem('selectedAddressIndex'), 10)
            : 0;
    });

    const {setVendorAddress} = useCart();
    
    const [isLoading, setIsLoading] = useState(false);
    const [deliveryAddress, setDeliveryAddress] = useState();
    const [deliveryFullAddress, setDeliveryFullAddress] = useState();
    const [cartData, setCartData] = useState([]);
    const [totalPrice, setTotalPrice] = useState(0);
    const [selectedFood, setSelectedFood] = useState(null);
    const [open, setOpen] = useState(false);
    const [vendorID, setVendorID] = useState(null);
    const [vendorName, setVendorName] = useState(null);
    const [openAddressList, setOpenAddressList] = useState(false);
    const [isMobile, setIsMobile] = useState(window.innerWidth <= 600);
    const { fetchCartCount, setSelectedAddress } = useCart();
    const navigate = useNavigate();
    const { t } = useTranslation();
    const [selectedOption, setSelectedOption] = useState('delivery');
    const handleOpenAdressList = () => setOpenAddressList(true);
    const handleCloseAddressList = () => setOpenAddressList(false);
    const videoRefs = useRef({});
    const [playingIndex, setPlayingIndex] = useState(null);
    const { notificationCountvalue } = useNotifications();
    const [NotificationOverlay, setNotificationOverlay] = useState(false);
    const [vendorDistance, setVendorDistance] = useState();
    const overlayRef = useRef(null);
    const isDeliveryDisabled = vendorDistance > 20;

    useEffect(() => {
        if (isDeliveryDisabled && selectedOption !== 'pickup') {
            setSelectedOption('pickup');
        }
    }, [isDeliveryDisabled, selectedOption]);


    const handlePlay = (e, index) => {
        e.stopPropagation();
        
        Object.entries(videoRefs.current).forEach(([key, video]) => {
            if (parseInt(key) !== index && video && !video.paused) {
                video.pause();
            }
        });
        
        const currentVideo = videoRefs.current[index];
        if (currentVideo) {
            currentVideo.play();
            setPlayingIndex(index);
        }
    };

    useEffect(() => {
        const storedIndex = localStorage.getItem('selectedAddressIndex');
        if (storedIndex !== null) {
            setSelectedAddressIndex(parseInt(storedIndex, 10));
        }
    }, []);

    useEffect(() => {
        const handleResize = () => {
            setIsMobile(window.innerWidth < 601);
        };
        window.addEventListener('resize', handleResize);
        return () => window.removeEventListener('resize', handleResize);
    }, []);

    useEffect(() => {
        axiosUserInstance
            .get('/address/account/account_id')
            .then((response) => {
                const addressList = response?.data?.addresses;
                if (addressList?.length > 0) {
                    setDeliveryAddress(
                        addressList[selectedAddressIndex]?.Delivery_name ||
              addressList[0]?.Delivery_name
                    );
                    setDeliveryFullAddress(
                        addressList?.[selectedAddressIndex]?.Address_line_1 +
              ' , ' +
              addressList?.[selectedAddressIndex]?.City +
              ' , ' +
              addressList?.[selectedAddressIndex]?.State +
              ' , ' +
              addressList?.[selectedAddressIndex]?.ZIP
                    );
                    setSelectedAddress(addressList?.[selectedAddressIndex]);
                    localStorage.setItem('selectedCustomerAddress', JSON.stringify(addressList?.[selectedAddressIndex]));
                }
            })
            .catch((error) => console.error('Error fetching addresses:', error));
    }, [selectedAddressIndex]);

    const handleUpdateDeliveryAddress = (newAddressType) => {
        setDeliveryAddress(newAddressType);
        localStorage.setItem('selectedAddressIndex', selectedAddressIndex);
    };

    const handleClose = () => {
        setOpen(false);
        setSelectedFood(null);
    };

    const fetchDataFromCart = async () => {
        const location = JSON.parse(localStorage.getItem('selectedLocation'));

        const lat = location?.lat;
        const lng = location?.lng;

        try {
            setIsLoading(true);
            const itemResponse = await axiosUserInstance.get('/cartdetails/cartsp', {
                params: {
                    latitude: lat,
                    longitude: lng,
                }
            });
            setIsLoading(false);
            const data = itemResponse?.data?.cartDetails?.[0];
            setVendorID(data?.Cart_Information?.[0]?.Vendor_Id);
            setVendorName(data?.Cart_Information?.[0]?.Vendor_Name);
            setCartData(data?.Cart_Information);
            setTotalPrice(data?.Cart_Total_Price);
            setVendorDistance(data?.Cart_Information?.[0]?.Distance_in_Miles);
        } catch (error) {
            setIsLoading(false);
            console.log('error in cart', error);
        }
    };

    useEffect(() => {
        fetchDataFromCart();
    }, []);

    const Increment = async (id) => {
        try {
            await axiosUserInstance.put(
                `/cartdetails/customer/vendor/${vendorID}/item/${id?.Item_ID}`,
                { Quantity: id?.Item_Quantity + 1 }
            );

            await fetchDataFromCart();
        } catch (error) {
            console.log('error in menu item increment', error);
        }
    };

    const Decrement = async (id) => {
        const newQuantity = id?.Item_Quantity - 1;

        if (newQuantity > 0) {
            try {
                await axiosUserInstance.put(
                    `/cartdetails/customer/vendor/${vendorID}/item/${id?.Item_ID}`,
                    { Quantity: newQuantity }
                );

                await fetchDataFromCart();
            } catch (error) {
                console.log('error in menu item decrement', error);
            }
        } else {
            try {
                await axiosUserInstance.delete(
                    `/cartdetails/customer/vendor/${vendorID}/${id?.Item_ID}`
                );

                await fetchDataFromCart();
                await fetchCartCount();
            } catch (error) {
                console.log('item remove from cart error', error);
            }
        }
    };

    const fetchOfferDetails = async (itemId) => {
        try {
            const response = await axiosVendorInstance.get(
                `/vendors/menuitems/particularitem/${itemId}`,
                { skipAuth: true }
            );
            setSelectedFood(response?.data?.menuItem);
            setOpen(true);
        } catch (error) {
            console.error('Error fetching offer details:', error);
        }
    };

    const handleOrderItem = () => {
        navigate('/reels');
    };

    const closenotificationoverlay = () => {
        setNotificationOverlay(false);
    };

    return (
        <div>
            <Helmet>
                <title>{SEO.CART_PAGE.TITLE}</title>
                <meta name="description" content={SEO.CART_PAGE.DESCRIPTION} />
                <meta name="keywords" content={SEO.CART_PAGE.KEYWORDS} />
                <meta name="robots" content="index, follow" />
                <link rel="canonical" href={SEO.CART_PAGE.CANONICAL} />

                <meta property="og:title" content={SEO.CART_PAGE.TITLE} />
                <meta property="og:description" content={SEO.CART_PAGE.DESCRIPTION} />
                <meta property="og:type" content={SEO.CART_PAGE.OG.TYPE} />
                <meta property="og:url" content={SEO.CART_PAGE.OG.URL} />
                <meta property="og:site_name" content={SEO.CART_PAGE.OG.SITE_NAME} />
                <meta property="og:image" content='https://omyfood.io/OMF_logo_bg.png' />
    
                <meta name="twitter:image" content='https://omyfood.io/OMF_logo_bg.png' />
                <meta name="twitter:title" content={SEO.CART_PAGE.TITLE} />
                <meta name="twitter:description" content={SEO.CART_PAGE.DESCRIPTION} />
                <meta
                    name="twitter:card"
                    content='summary_large_image'
                />

                <script
                    type="application/ld+json"
                    dangerouslySetInnerHTML={{
                        __html: JSON.stringify({
                            '@context': 'https://schema.org',
                            '@graph': [
                                {
                                    '@type': 'WebPage',
                                    '@id': `${CONSTANT.OMYFOOD_WEB_LINK}/cart`,
                                    'url': `${CONSTANT.OMYFOOD_WEB_LINK}/cart`,
                                    'name': 'Cart - Omyfood',
                                    'description': 'View and manage your selected food items before placing your order for pickup or delivery with Omyfood.',
                                    'breadcrumb': {
                                        '@type': 'BreadcrumbList',
                                        'itemListElement': [
                                            {
                                                '@type': 'ListItem',
                                                'position': 1,
                                                'name': 'Home',
                                                'item': `${CONSTANT.OMYFOOD_WEB_LINK}`
                                            },
                                            {
                                                '@type': 'ListItem',
                                                'position': 2,
                                                'name': 'Cart',
                                                'item': `${CONSTANT.OMYFOOD_WEB_LINK}/cart`,
                                            }
                                        ]
                                    },
                                    'isPartOf': {
                                        '@type': 'WebSite',
                                        'name': 'Omyfood',
                                        'url': `${CONSTANT.OMYFOOD_WEB_LINK}`
                                    }
                                },
                                {
                                    '@type': 'Organization',
                                    '@id': `${CONSTANT.OMYFOOD_WEB_LINK}/dashboard`,
                                    'name': `${CONSTANT.OMYFOOD}`,
                                    'url': `${CONSTANT.OMYFOOD_WEB_LINK}`,
                                    'logo': {
                                        '@type': 'ImageObject',
                                        'url': 'https://omyfood.io/OMF_logo_bg.png'
                                    },
                                },
                                {
                                    '@type': 'ItemList',
                                    'name': 'Cart Items',
                                    'itemListOrder': 'https://schema.org/ItemListUnordered',
                                    'numberOfItems': 2
                                }
                            ]
                        })
                    }}
                />


            </Helmet>


            <div className="topmenubar-cart">
                <SideMenuBar></SideMenuBar>

                <div className="topbar-cart">
                    <TopMenuBar></TopMenuBar>
                </div>
            </div>

            <div className="cart-mobile-header">
                <div className="cart-header-item-container">
                    <h2 className="review-order-heading">{t('cart.review-order')}</h2>
                </div>
                <NotificationIcon 
                    color={'white'} 
                    className="notification-icon" 
                    notificationcount={notificationCountvalue}
                    onClick={() => setNotificationOverlay(!NotificationOverlay)}
                />
                {NotificationOverlay && (
                    <>
                        <div className='arrow-to-point-notification'></div>
                        <div className='notification-overlay' ref={overlayRef} style={{top:'75px'}}>
                            <Notification closeOverlay={closenotificationoverlay} />
                        </div>
                    </>
                )}
            </div>

            <div className="cart-container">
                <div className="cart-box">
                    {isLoading ? (
                        <Loader />
                    ) : cartData || cartData?.length > 0 ? (
                        <>
                            <div className="add-to-cart">Add To Cart</div>
                            <div className="cart-box-border">
                                <div className="cart-items-details cart-box-border1">
                                    {cartData?.map((item, index) => {
                                        const maxLength = isMobile ? 50 : 90;
                                        const rawDescription =
                      item?.MenuItem_Description || 'No description available';
                                        const strippedDescription = rawDescription.replace(
                                            /<[^>]+>/g,
                                            ''
                                        );
                                        const shortDescription =
                      strippedDescription.length > maxLength
                          ? strippedDescription.slice(0, maxLength) + '...'
                          : strippedDescription;

                                        return (
                                            <div className="item-container-cart" key={index} onClick={() => fetchOfferDetails(item?.Item_ID)}>
                                                <div className="cart-media-wrapper" >
                                                    {item?.MenuItem_Avatar?.match(/\.(mp4|webm|ogg)$/i) ? (
                                                        <div className="cart-video-container1">
                                                            <video
                                                                src={item?.MenuItem_Avatar}
                                                                muted
                                                                playsInline
                                                                // eslint-disable-next-line react/no-unknown-property
                                                                webkit-playsinline='true'
                                                                preload="metadata"
                                                                className="cart-food-video"
                                                                ref={(el) => videoRefs.current[index] = el}
                                                                onClick={(e) => {
                                                                    e.stopPropagation();
                                                                    const video = videoRefs.current[index];
                                                                    if (video && !video.paused) {
                                                                        video.pause();
                                                                        setPlayingIndex(null);
                                                                    }
                                                                }}
                                                                onEnded={() => setPlayingIndex(null)}
                                                                onError={(e) => {
                                                                    e.target.poster = img1;
                                                                }}
                                                            />
                                                            {playingIndex !== index && (
                                                                <button onClick={(e) => handlePlay(e, index)} className='play-btn'>
                                                                    <IoPlayOutline color='white' fontSize={34} />
                                                                </button>
                                                            )}

                                                        </div>
                                                    ) : (
                                                        <img
                                                            className='cart-Food-image'
                                                            src={item?.MenuItem_Avatar || img1}
                                                            alt='Food img'
                                                            onError={(e) => {
                                                                e.target.src = img1;
                                                            }}
                                                        />
                                                    )}
                                                </div>
                                                <div className="item-details-order1">
                                                    <div
                                                        style={{ cursor: 'pointer' }}
                                                    >
                                                        <div className="item-row1">
                                                            <div className="row1">
                                                                <img
                                                                    className="item-reddot-order"
                                                                    src={
                                                                        item.MenuItem_Vegetarian === 1
                                                                            ? greenDot
                                                                            : item.MenuItem_Vegetarian === 0
                                                                                ? redDot
                                                                                : ''
                                                                    }
                                                                    alt="dot"
                                                                />
                                                                <h5 className="item-name-order">
                                                                    {item?.MenuItem_Name}
                                                                </h5>
                                                            </div>
                                                        </div>

                                                        <div className="order-item-row2">
                                                            <p className="item-desc-order1">
                                                                {shortDescription}
                                                            </p>
                                                        </div>
                                                    </div>
                                                    <div className="add-menu-item-between-line"></div>
                                                    <div className="desc-add-item">
                                                        {location.pathname !== '/cart' && <p></p>}
                                                        <div
                                                            className="quantity-controls"
                                                            onClick={(e) => e.stopPropagation()}
                                                            style={{
                                                                marginLeft: '0',
                                                                backgroundColor: '#FCFCFC',
                                                                border: '1px solid #E7E7E7',
                                                            }}
                                                        >
                                                            <span
                                                                onClick={() => Decrement(item)}
                                                                style={{ color: '#333333' }}
                                                            >
                                -
                                                            </span>
                                                            <div
                                                                className="quantity-number"
                                                                style={{ color: '#333333' }}
                                                            >
                                                                {item?.Item_Quantity}
                                                            </div>
                                                            <span
                                                                onClick={() => Increment(item)}
                                                                style={{ color: '#333333' }}
                                                            >
                                +
                                                            </span>
                                                        </div>
                                                        {location.pathname === '/cart' && (
                                                            <p className="item-cost-orderr">
                                $ {item?.Total_Price}
                                                            </p>
                                                        )}
                                                    </div>
                                                </div>
                                            </div>
                                        );
                                    })}
                                </div>
                                {cartData?.length > 0 && (
                                    <AddOns
                                        cartData={cartData}
                                        fetchDataFromCart={fetchDataFromCart}
                                        onVendorDetails={(vendorDetails) => {
                                            setVendorAddress(vendorDetails);
                                        }}                                        
                                    />
                                )}
                            </div>

                            <div className="cart-box-border">
                                <div className="delivery-pickup-container">
                                    <div
                                        className={`delivery-container ${
                                            selectedOption === 'delivery' ? 'selected' : ''
                                        } ${isDeliveryDisabled ? 'disabled' : ''}`}
                                        onClick={() => {
                                            if (!isDeliveryDisabled) setSelectedOption('delivery');
                                        }}
                                    >
                                        <div className="input-redio-cart">
                                            <input
                                                className="input-radio"
                                                name="food"
                                                id="delivery"
                                                type="radio"
                                                checked={selectedOption === 'delivery'}
                                                disabled={isDeliveryDisabled}
                                                readOnly
                                            />
                                        </div>
                                        <label 
                                            htmlFor="delivery" 
                                            className="text"
                                            style={{ cursor: isDeliveryDisabled ? 'not-allowed' : 'pointer' }}
                                        >
                                            {t('payment.delivery')}
                                        </label>
                                    </div>

                                    <div
                                        className={`delivery-container ${
                                            selectedOption === 'pickup' ? 'selected' : ''
                                        }`}
                                        onClick={() => setSelectedOption('pickup')}
                                    >
                                        <div className="input-redio-cart">
                                            <input
                                                className="input-radio"
                                                name="food"
                                                id="pickup"
                                                type="radio"
                                                checked={selectedOption === 'pickup'}
                                            />
                                        </div>
                                        <label htmlFor="pickup" className="text">
                                            {t('payment.pickup')}
                                        </label>
                                    </div>
                                </div>
                            </div>

                            {cartData?.length > 0 && selectedOption === 'delivery' && (
                                <div
                                    className="address-container1"
                                    onClick={() => handleOpenAdressList()}
                                >
                                    <div className="delivery-location-home-desc-container-1">
                                        <WhiteLocationIcon />
                                        <div className="delivert-to-home-desc-container">
                                            <h3 className="delivery-to-home-text">
                                                {' '}
                                                {t('cart.delivery-to')} {deliveryAddress}
                                            </h3>
                                            <p className="delivery-to-home-address">
                                                {deliveryFullAddress || ''}
                                            </p>
                                        </div>
                                    </div>

                                    <DownArrowIcon />
                                </div>
                            )}
                            {openAddressList && (
                                <Address
                                    open={openAddressList}
                                    handleClose={handleCloseAddressList}
                                    handleUpdateDeliveryAddress={handleUpdateDeliveryAddress}
                                    selectedAddressIndex={selectedAddressIndex}
                                    setSelectedAddressIndex={setSelectedAddressIndex}
                                />
                            )}
                            <div className="items-andprice-container">
                                <div className='items-scroll-div'>
                                    {cartData?.map((item, index) => {
                                        return (
                                            <div key={index} className="item-name-and-price-container">
                                                <p>{item?.MenuItem_Name}</p>
                                                <p>${item?.MenuItem_Price * item?.Item_Quantity}</p>
                                            </div>
                                        );
                                    })}
                                </div>
                                <div className="item-sub-total-conatiner-padding">
                                    <div className="menu-item-line"></div>
                                    <div className="sub-total-area">
                                        <div className="sub-total-text-data">
                                            {t('cart.total-title')} : {''}${totalPrice}
                                        </div>
                                    </div>
                                </div>
                            </div>
                            {cartData?.length > 0 && (
                                <>
                                    <SubTotal 
                                        totalPrice={totalPrice}
                                        selectedAddress={deliveryAddress}
                                        selectedOption={selectedOption}
                                        vendorID={vendorID}
                                        vendorName={vendorName}
                                        deliveryFullAddress={deliveryFullAddress}
                                        lineItems={cartData.map(item => ({
                                            reference: 'food item',
                                            quantity: item.Item_Quantity,
                                            amount: item.MenuItem_Price * 100,
                                            'tax_behavior': 'exclusive',
                                            'tax_code': 'txcd_40060003',
                                        }))}
                                    />
                                </>
                            )}
                        </>
                    ) : (
                        <div className="empty-cart-container">
                            <img
                                className="empty-cart-img"
                                src={emptyCartImg}
                                alt="empty-cart"
                                loading="lazy"
                            />
                            <h1 className="empty-cart-text"> Your Cart Empty</h1>
                            <button className="continue-to-order" onClick={handleOrderItem}>
                Continue to order
                            </button>
                        </div>
                    )}
                </div>
            </div>

            <RightSideBar/>

            {selectedFood && (
                <FoodMenuDetailsModal
                    open={open}
                    handleClose={handleClose}
                    food={selectedFood}
                    orderBtn={false}
                />
            )}
        </div>
    );
}

export default cart;
